<div>
	<sim-recorder-camera-fin [screen]="camera" [liveStreamCameraLayoutOptions]="options" />
</div>
